export default function LogoMark({ className = "h-10 w-10" }) {
  return (
    <svg
      viewBox="0 0 48 48"
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <rect x="2" y="30" width="14" height="8" rx="1" fill="currentColor" />
      <rect x="18" y="30" width="14" height="8" rx="1" fill="currentColor" opacity="0.55" />
      <rect x="34" y="30" width="12" height="8" rx="1" fill="currentColor" />
      <rect x="9" y="20" width="14" height="8" rx="1" fill="currentColor" opacity="0.55" />
      <rect x="25" y="20" width="14" height="8" rx="1" fill="currentColor" />
      <rect x="16" y="10" width="14" height="8" rx="1" fill="currentColor" />
    </svg>
  );
}
